<template>
  <div class="about">
    <div class="about-content">
      <div class="about-img">
        <img :src="$imgUrl + aboutInfo.images" alt="" />
      </div>

      <div class="about-text">
        <div>
          <div class="title-es">ABOUT</div>
          <div class="title-es">US <span></span></div>
        </div>
        <h4>{{ aboutInfo.title }}</h4>
        <div class="desc" v-html="aboutInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  props: {
    aboutInfo: Object,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.about {
  position: relative;
  padding-top: 148px;
  overflow: hidden;
  min-width: 1440px;
  max-width: 1920px;
  margin: 0 auto;
  letter-spacing: 0.1em;

  .title-es {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    letter-spacing: 2px;
    padding: 0;
    vertical-align: top;
  }

  >p:first-of-type {
    border-bottom: 1px solid #333;
    width: 72px;
  }

  .about-content {
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .about-img {
      box-sizing: border-box;
      padding-right: 80px;

      img {
        width: 640px;
        height: 480px;
      }
    }

    .about-text {
      box-sizing: border-box;
      width: 40%;

      h4 {
        margin-top: 35px;
        line-height: 1.5em;
        font-size: 30px;
        font-weight: bold;
        color: #000000;
      }

      .title-es {
        position: relative;
      }

      span {
        position: absolute;
        content: '';
        display: block;
        width: 48px;
        bottom: 15px;
        left: 80px;
        height: 6px;
        background: #FFC000;
      }

      .desc {
        margin-top: 24px;
        width: 680px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
        text-align: justify;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutUs.vue